import { render, staticRenderFns } from "./MonitorDetails.vue?vue&type=template&id=5af3191e&scoped=true&"
import script from "./MonitorDetails.vue?vue&type=script&lang=js&"
export * from "./MonitorDetails.vue?vue&type=script&lang=js&"
import style1 from "./MonitorDetails.vue?vue&type=style&index=1&id=5af3191e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af3191e",
  null
  
)

export default component.exports